import { render, staticRenderFns } from "./GuidedProductsReviewSection.vue?vue&type=template&id=f21b226e&scoped=true&"
import script from "./GuidedProductsReviewSection.vue?vue&type=script&lang=js&"
export * from "./GuidedProductsReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./GuidedProductsReviewSection.vue?vue&type=style&index=0&id=f21b226e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21b226e",
  null
  
)

export default component.exports